import React, { useState, useCallback, forwardRef } from 'react';
import { Group, SearchOutlined, InputGroup, Input, Box } from '@landr/maestro';
import { CollectionsList } from '../CollectionsList';

export interface CollectionsListPopoverProps
    extends React.HTMLAttributes<HTMLDivElement> {
    sampleIds?: string[];
    hide: () => void;
    placeholder?: string;
}

const CollectionsListPopover = forwardRef(
    (
        { sampleIds, hide, placeholder }: CollectionsListPopoverProps,
        ref: React.Ref<HTMLDivElement>,
    ) => {
        const [query, onSearch] = useState('');

        const onChange = useCallback(
            (e: React.ChangeEvent<HTMLInputElement>) =>
                onSearch(e.target.value),
            [onSearch],
        );

        return (
            <Box ref={ref} height="392px" width={{ base: '100%', md: '320px' }}>
                <Group direction="vertical" pb="0" gap="none">
                    <Group.Item p="sm">
                        <InputGroup>
                            <Input
                                size="md"
                                placeholder="Search"
                                value={query}
                                onChange={onChange}
                                onKeyDownCapture={(
                                    event: React.KeyboardEvent<HTMLInputElement>,
                                ) => {
                                    event.stopPropagation();
                                }}
                            />
                            <InputGroup.Icon placement="right">
                                <SearchOutlined />
                            </InputGroup.Icon>
                        </InputGroup>
                    </Group.Item>
                    <Group.Item paddingX="md">
                        <CollectionsList
                            sampleIds={sampleIds}
                            hide={hide}
                            searchString={query}
                            placeholder={placeholder}
                        />
                    </Group.Item>
                </Group>
            </Box>
        );
    },
);

export default CollectionsListPopover;
